import { WorkspaceSettingsDomainFacade } from '@mode/workspace-settings/domain';
import * as angular from 'angular';
import { BehaviorSubject } from 'rxjs';

import { BugsnagHelpers } from '~/lib/bugsnag-helpers';

export class ReportSchedulesController {
  //bindings
  private reportToken: string;
  private account: any;

  //locals
  private resources$: BehaviorSubject<any> = new BehaviorSubject(null);

  static $inject = ['SchedulesModalService', 'workspaceSettingsDomainFacade'];

  constructor(
    private SchedulesModalService: any,
    private workspaceSettingsDomainFacade: WorkspaceSettingsDomainFacade
  ) {}

  $onInit() {
    this.getResources(this.reportToken);
  }

  getResources(reportToken: string) {
    try {
      const orgUsername = this.workspaceSettingsDomainFacade.getCurrentOrgUsername();
      this.SchedulesModalService.fetchSchedulesResources(this.reportToken, orgUsername).then((resources) => {
        this.resources$.next(resources);
      });
    } catch (err) {
      BugsnagHelpers.notifySafely(err);
    }
  }

  handleSchedulesUpdate() {
    this.getResources(this.reportToken);
  }

  getReportLinkText() {
    const resource = this.resources$.getValue();
    if (resource) {
      //If a report is untitled, return report URL, otherwise, return report name
      return resource.report.name ? resource.report.name : resource.report.share;
    }
  }
}

export const ReportSchedulesComponent: angular.IComponentOptions = {
  controller: ReportSchedulesController,
  controllerAs: 'ctrl',
  bindings: {
    account: '<',
    reportToken: '@',
  },
  template: `
  <h5>
    <a ng-href="{{(ctrl.resources$ | async).report.link}}">
      {{ctrl.getReportLinkText()}}
    </a>
  </h5>
  <report-schedules-list
    report="(ctrl.resources$ | async).report"
    account="ctrl.account"
    schedules="(ctrl.resources$ | async).schedules"
    report-run="(ctrl.resources$ | async).reportRun"
    owner="(ctrl.resources$ | async).owner"
    on-schedules-update="ctrl.handleSchedulesUpdate()"
  </report-schedules-list>
  `,
};
